type Props = {
  condition: boolean,
  ifComponent: JSX.Element,
  elseComponent: JSX.Element,
}


export default function IfElseComponent({condition, ifComponent, elseComponent}: Props){
  return (
    <>
      {condition && ifComponent}
      {!condition && elseComponent}
    </>
  )
}